import { render } from "./App.vue?vue&type=template&id=7dec657d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7dec657d&lang=scss"
import "./App.vue?vue&type=style&index=1&id=7dec657d&lang=css"

import exportComponent from "/data/fe-node-modules/beta-ab/candao-h5-v6-phd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__